import React from "react";
import { useLocation } from "react-router-dom";
import { CustomButton } from "components/Button";
import { TableIcon } from "./checkout/components/DineInTableNo";
import { SubHeadingText } from "components/TextTranslationContainer";
import { useDineIn } from "./hooks";

const TableNotFound = () => {
  const location = useLocation();
  const { goBack } = useDineIn();
  const queryParams = new URLSearchParams(location.search);
  const tableNo = queryParams.get("table-number");
  return (
    <div className="flex flex-col gap-6 items-center justify-center h-screen w-full m-4 p-4">
      <div className="flex items-center gap-2">
        <TableIcon />
        <SubHeadingText
          text={"Table Number"}
          contentProps={{ tableNo }}
          style={{
            fontSize: "16px",
            textDecoration: "line-through",
            textDecorationColor: "red",
            textDecorationThickness: "1px",
          }}
        />
      </div>
      <SubHeadingText
        text={
          "The table number you entered not found. Please ask the manager to get a new table."
        }
        style={{ textAlign: "center" }}
      />
      {/* <CustomButton title={"Go Back"} onClick={goBack} className="w-full" /> */}
    </div>
  );
};

export default TableNotFound;
